import { useEffect, useMemo, useState } from 'react'
export default function ColorPaletteViewer({ palettes }) {
  const paletteNames = Object.keys(palettes)

  const [activePalette, setActivePalette] = useState(
    paletteNames.includes('All') ? 'All' : paletteNames[0]
  )

  const activeSwatches = useMemo(() => {
    return palettes[activePalette] || []
  }, [palettes, activePalette])

  const [selectedSwatch, setSelectedSwatch] = useState(
    activeSwatches[0] || null
  )

  useEffect(() => {
    setSelectedSwatch(activeSwatches[0] || null)
  }, [activePalette])

  return (
    <div className="lexcms-color-picker">

      <div className="lexcms-palette-filter">

        <div className="lexcms-filter-title">
          Filter By Palette
        </div>

        <div className="lexcms-palette-tabs">
          {paletteNames.map((palette) => (
            <button
              key={palette}
              onClick={() => setActivePalette(palette)}
              className={
                activePalette === palette
                  ? "lexcms-palette-tab active"
                  : "lexcms-palette-tab"
              }
            >
              {palette} ({palettes[palette].length})
            </button>
          ))}
        </div>
      </div>

      <div className="lexcms-color-layout">

        <div className="lexcms-color-preview">

          <div className="lexcms-preview-image">

            {selectedSwatch &&
              (selectedSwatch.color_system === "Custom" ? (
                <img
                  src={selectedSwatch.image_url}
                  alt={selectedSwatch.name}
                />
              ) : (
                <div
                  className="lexcms-preview-color"
                  style={{
                    backgroundColor: selectedSwatch.color_display
                  }}
                />
              ))}

          </div>

          {selectedSwatch && (
            <div className="lexcms-preview-footer">

              <div className="lexcms-preview-name">
                {selectedSwatch.name}
              </div>

              <div className="lexcms-preview-detail">
                {selectedSwatch.color_system || "Hex"}
              </div>

            </div>
          )}

        </div>

        <div className="lexcms-swatch-grid">

          {activeSwatches.map((swatch) => {

            const selected =
              selectedSwatch &&
              selectedSwatch.name === swatch.name

            return (
              <button
                key={swatch.name}
                className="lexcms-swatch"
                onClick={() => setSelectedSwatch(swatch)}
              >

                <div
                  className={
                    selected
                      ? "lexcms-swatch-circle selected"
                      : "lexcms-swatch-circle"
                  }
                >

                  {swatch.color_system === "Custom" ? (
                    <img
                      src={swatch.image_url}
                      alt={swatch.name}
                    />
                  ) : (
                    <div
                      className="lexcms-swatch-fill"
                      style={{
                        backgroundColor: swatch.color_display
                      }}
                    />
                  )}

                </div>

                <div className="lexcms-swatch-name">
                  {swatch.name}
                </div>

              </button>
            )

          })}

        </div>

      </div>

    </div>
  )
}
